<script lang="ts">
	import type { SvelteAsr } from 'client/types/common'
	import { ReportViewer } from '@isoftdata/svelte-report-viewer'

	interface Props {
		asr: SvelteAsr
	}

	let { asr }: Props = $props()

	let selectedTab: 'Reports' | 'History' | 'Subscriptions' = $state(getSelectedTab(asr.getActiveState().name))

	function getSelectedTab(stateName: string) {
		if (stateName.includes('subscriptions')) {
			return 'Subscriptions'
		} else if (stateName.includes('history')) {
			return 'History'
		} else {
			return 'Reports'
		}
	}
	$effect(() => {
		selectedTab = getSelectedTab(asr.getActiveState().name)
	})
</script>

<ReportViewer
	reportsHref={asr.makePath('app.report-viewer.reports')}
	historyHref={asr.makePath('app.report-viewer.history')}
	subscriptionsHref={asr.makePath('app.report-viewer.report-subscriptions')}
	bind:selectedTab
>
	<uiView></uiView>
</ReportViewer>
